import { createReducer, on } from "@ngrx/store";
import { AuthOauthState } from "./auth.state";
import { AuthOauthActions } from "./auth.actions";

// const OAUTH_CODE_VERIFIER = "oauthCodeVerifier";
// const OATH_STATE = "oauthState";
// const OATH_TOKEN = "oauthToken";

// const savedOauthState: string = sessionStorage.getItem(OATH_STATE) ?? "";
// const savedOauthCodeVerifier: string = sessionStorage.getItem(OAUTH_CODE_VERIFIER) ?? "";
// const savedOauthToken: string | null = sessionStorage.getItem(OATH_TOKEN);
//
// const initialOauthTokenDto = savedOauthToken ? JSON.parse(savedOauthToken) : null;
// const initialOauthToken = initialOauthTokenDto ? new OauthToken(initialOauthTokenDto._accessToken?._token, initialOauthTokenDto._refreshToken) : null;
// const initialOauthState = savedOauthState;
// const initialOauthCodeVerifier = savedOauthCodeVerifier;
const AUTH_OAUTH_STATE = "AuthOauthState";
export const defaultAuthOauthState: AuthOauthState = {
  oauthState: {
    value: "",
  },
  oauthCodeVerifier: { //needed when routing b/t F5 and angular
    value: "",
  },
  oauthToken: { // needed when routing b/t email and login-callback
    accessToken: "",
    refreshToken: "",
  },
};

const savedOauthState: string | null = sessionStorage.getItem(AUTH_OAUTH_STATE);
const initialAuthOauthState: AuthOauthState = savedOauthState ? JSON.parse(savedOauthState) : defaultAuthOauthState;
// console.log("initial oauth...", initialAuthOauthState);

export const authOauthReducer = createReducer(
  initialAuthOauthState,

  on(AuthOauthActions.saveOauthState, (state, action) => {
    const newState: AuthOauthState = {
      ...state,
      oauthState: {
        value: action.oauthStateValue,
      },
    };
    sessionStorage.setItem(AUTH_OAUTH_STATE, JSON.stringify(newState));
    // console.log({
    //   message: "saving state ...",
    //   stateValue: action.oauthStateValue,
    //   newState
    // })
    return newState;
  }),

  on(AuthOauthActions.saveOauthCodeVerifier, (state, action) => {
    // sessionStorage.setItem(OAUTH_CODE_VERIFIER, action.oauthCodeVerifier);
    const newState: AuthOauthState = {
      ...state,
      oauthCodeVerifier: {
        value: action.oauthCodeVerifierValue,
      },
    };
    sessionStorage.setItem(AUTH_OAUTH_STATE, JSON.stringify(newState));
    // console.log({
    //   message: "saving code verifier  ...",
    //   codeVerifierValue: action.oauthCodeVerifierValue,
    //   newState
    // })
    return newState;
  }),

  on(AuthOauthActions.clearOauthCodeVerifier, (state, action) => {
    // sessionStorage.setItem(OAUTH_CODE_VERIFIER, "");
    const newState: AuthOauthState = {
      ...state,
      oauthCodeVerifier: {
        value: "",
      },
    };
    sessionStorage.setItem(AUTH_OAUTH_STATE, JSON.stringify(newState));
    // console.log({
    //   message: "clearing code verifier  ...",
    //   newState
    // })
    return newState;
  }),

  on(AuthOauthActions.saveOauthToken, (state, action) => {
    // sessionStorage.setItem(OATH_TOKEN, JSON.stringify(action.oauthToken));
    const newState: AuthOauthState = {
      ...state,
      oauthToken: {
        accessToken: action.oauthAccessTokenValue,
        refreshToken: action.oauthRefreshTokenValue,
      },
    };
    sessionStorage.setItem(AUTH_OAUTH_STATE, JSON.stringify(newState));
    // console.log({
    //   message: "saving token ...",
    //   accessToken: action.oauthAccessTokenValue,
    //   refreshToken: action.oauthRefreshTokenValue,
    //   newState
    // })
    return newState;
  })
);

//
// export const oauthStateReducer = createReducer(
//   savedOauthState,
//   on(saveOauthState, (state, action) => {
//     sessionStorage.setItem(OATH_STATE, action.oauthState);
//     return action.oauthState;
//   })
// );
//
// export const oauthCodeVerifierReducer = createReducer(
//   savedOauthCodeVerifier,
//   on(saveOauthCodeVerifier, (state, action) => {
//     sessionStorage.setItem(OAUTH_CODE_VERIFIER, action.oauthCodeVerifier);
//     return action.oauthCodeVerifier;
//   })
// );
//
// export const oauthTokenReducer = createReducer(
//   initialOauthToken,
//   on(saveOauthToken, (state, action) => {
//     sessionStorage.setItem(OATH_TOKEN, JSON.stringify(action.oauthToken));
//     return action.oauthToken;
//   })
// );
